export default __webpack_public_path__ + "static/media/icons8-heart-30 (1) 1.b8b58464.svg";